import { all } from 'redux-saga/effects';
import importedOrganizationSaga from './importedOrganization';

export default function* importedOrganizationModuleSaga() {
  yield all([importedOrganizationSaga()]);
}
